var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"systemSettings"}},[_vm._v(" 个人中心 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }